import { useState } from "react";
import Login from "./components/Login";
import App from "./App";

function Main() {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);

  const handleLogin = (username, role) => {
    setUser(username);
    setRole(role);
  };

  const handleLogout = () => {
    setUser(null);
    setRole(null);
  };

  return (
    <>
      {!user ? (
        <Login onLogin={handleLogin} />
      ) : (
        <App user={user} role={role} onLogout={handleLogout} />
      )}
    </>
  );
}

export default Main;
